import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "../../helpers/axios";
import { showError } from "../../helpers/Notifications/Notification";
import { GET_SURVEY_STATUS } from "../../helpers/url_helpers";

export const getSurveyStatus = createAsyncThunk(
  "client/survey-status/",
  async () => {
    try {
      const response = await api.get(GET_SURVEY_STATUS);
      return response.data;
    } catch (e) {
      return new Error(e);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    surveyStatus: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getSurveyStatus.fulfilled, (state, action) => {
      if (action?.payload?.data?.error) {
        showError(
          action.payload.data?.error?.detail ||
            action.payload.data?.message ||
            "Failed to fetch notification"
        );
        state.loading = false;
      } else {
        state.surveyStatus = action.payload.data;
        state.loading = false;
      }
    });

    builder.addCase(getSurveyStatus.rejected, (state, action) => {
      showError("Failed to fetch notification");
      state.loading = false;
    });

    builder.addCase(getSurveyStatus.pending, (state, action) => {
      state.loading = true;
    });
  },
});

export default notificationSlice.reducer;
